
import React from 'react';

export const AboutContentSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Our Story
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              For over 13 years, Prime Meridian Travel has been dedicated to creating unforgettable travel experiences that span across generations. We believe that travel is not just about reaching a destination – it's about the journey, the connections made, and the memories created along the way.
            </p>
            <p className="text-lg text-gray-700 mb-6">
              Founded with a passion for exploration and a commitment to excellence, we have grown from a small tour operators to a trusted partner for families, couples, and adventurers seeking authentic and meaningful travel experiences.
            </p>
            <p className="text-lg text-gray-700">
              Our expertise spans across all continents, offering everything from luxury cruises to adventurous expeditions, cultural immersions to relaxing retreats. We take pride in our personalized approach, ensuring each journey is tailored to our clients' unique preferences and dreams.
            </p>
          </div>

          {/* Image */}
          <div className="relative">
            <img
              src="/images/about-content-section.jpg"
              alt="Prime Meridian Travel Office"
              className="rounded-lg shadow-xl w-full h-96 object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
